import { render, staticRenderFns } from "./AllReviews.vue?vue&type=template&id=f638e654&"
import script from "./AllReviews.vue?vue&type=script&lang=js&"
export * from "./AllReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports